"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconSVGFile = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var IconAssets = require("./IconAssets");
var IconSVGFile = function (props) {
    var _a, _b;
    var attributes = {};
    if (props.className) {
        attributes.className = props.className;
    }
    var prefix = '';
    if (props.theme && props.theme.toLowerCase() === 'bankwest') {
        prefix = 'BW';
    }
    // based on the version of react-scripts, get the image src
    var imgSrc = IconAssets[prefix + props.symbol];
    if ((_a = IconAssets[prefix + props.symbol]) === null || _a === void 0 ? void 0 : _a.default) {
        imgSrc = (_b = IconAssets[prefix + props.symbol]) === null || _b === void 0 ? void 0 : _b.default;
    }
    return (React.createElement("img", __assign({ src: imgSrc, alt: "", "aria-hidden": true }, attributes)));
};
exports.IconSVGFile = IconSVGFile;
// tslint:disable no-string-literal
exports.IconSVGFile['propTypes'] = {
    className: PropTypes.string,
    symbol: PropTypes.oneOf(Object.keys(IconAssets).concat(Object.keys(IconAssets).map(function (name) { return name.replace(/BW/g, ''); }))).isRequired,
    theme: PropTypes.string,
};
// tslint:enable no-string-literal
